import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

import routerBeforeAction from "@/utils/routerBeforeAction";

import {
  routerHome,
  routerHelp,
  routerOutbound,
  routerTracking,
  routerMypage,
  routerSignin,
  routerSignup,
  routerOauth,
  routerSSO,
  routerService,
  routerBenefit,
  routerNotFound,
} from "./children";

const routes: Array<RouteRecordRaw> = [
  routerHome,
  routerOutbound,
  routerTracking,
  routerHelp,
  routerMypage,
  routerSignin,
  routerSignup,
  routerOauth,
  routerSSO,
  routerService,
  routerBenefit,
  routerNotFound,
  {
    path: "/tradingStatement",
    name: "router.tracking-trading-statement",
    component: () => import("@/views/tradingStatement.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

// 라우터 변경 전 Action
routerBeforeAction(router);

export default router;
